import Style from './index.module.less'
import InfoCard, { type I_cardInfoItem } from '@/components/CardOne'
import { type Block, type Stats } from '@/hoxStore/interface'
import IMG_BlockTime from '@/assets/image/gea/block_time_1.svg'
import IMG_BlockHeight from '@/assets/image/gea/block_height_1.svg'
import IMG_Circulation from '@/assets/image/gea/circulation.png'
import IMG_Transaction from '@/assets/image/gea/transaction_2.svg'
import IMG_NationalZone from '@/assets/image/gea/national_zone.svg'
import IMG_Pledge from '@/assets/image/gea/pledge.png'
import IMG_VaultGea from '@/assets/image/gea/vault_gea.png'
import IMG_ActiveVerifiedAddress from '@/assets/image/gea/active_verified_address.png'
import { useEffect, useRef, useState } from 'react'
import { isEmptyOrNil } from '@/utils'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import {
  divideByHundredMillion,
  formatDecimalCus,
  formatDecimalPlaces,
  numInPlus,
  removeTrailingZeros,
  ugeaToGea2,
} from '@/utils/number'
import { useBlockStore } from '@/hoxStore/block'

/**
 * 获取首页数据卡片列表
 * @param t 多语言函数
 * @returns
 */
const getList = (t: any) => {
  const list: { left: I_cardInfoItem[]; right: I_cardInfoItem[] } = {
    left: [
      {
        // 平均出块时间
        title: `${t('explorer_11')}`,
        num: '-',
        key: 'averageBlockTimePerHour',
        icon: IMG_BlockTime,
        className: 'averageBlockTimePerHour_bg',
      },
      {
        // 最新区块
        title: `${t('explorer_9')}`,
        num: '-',
        key: 'blocksHeight',
        icon: IMG_BlockHeight,
        noPercentile: true,
        className: 'blocksHeight_bg',
      },
      {
        // 总流通量
        title: `${t('explorer_297')} (GEA)`,
        key: 'totalLiquidity',
        // mecUnit: false,
        num: '-',
        icon: IMG_Circulation,
        tip: t('explorer_297_desc'),
        needShowAll: true,
        originNum: 0,
        className: 'totalLiquidity_bg',
      },

      {
        // 总质押量
        title: `${t('explorer_55')} (GEA)`,
        key: 'totalStakeAndRegionNumtotalStakeSum',
        num: '-',
        icon: IMG_Pledge,
        // mecUnit: true,
        tip: `${t('explorer_298')}`,
        needShowAll: true,
        originNum: 0,
        className: 'totalStakeAndRegionNumtotalStakeSum_bg',
      },
    ],
    right: [
      {
        // 国家区
        title: `${t('explorer_1')}`,
        key: 'totalStakeAndRegionNum',
        num: '-',
        icon: IMG_NationalZone,
        className: 'totalStakeAndRegionNum_bg',
      },
      {
        // 全网交易次数
        title: `${t('explorer_14')}`,
        key: 'rollAppCountTotalTransitionHub',
        num: '-',
        icon: IMG_Transaction,
        noPercentile: false,
        className: 'rollAppCountTotalTransitionHub_bg',
        // mecUnit: false,
      },

      {
        // 全网金库总量
        title: `${t('explorer_296')} (GEA)`,
        key: 'totalTreasureAmount',
        num: '-',
        icon: IMG_VaultGea,
        // mecUnit: true,
        tip: `${t('explorer_296_desc1')}`,
        needShowAll: true,
        originNum: 0,
        className: 'totalTreasureAmount_bg',
      },
      {
        // 活跃地址数/已认证地址
        title: `${t('explorer_15')}/${t('explorer_16')}`,
        key: 'activeAddressCount',
        num: '-',
        num1: '-',
        icon: IMG_ActiveVerifiedAddress,
        className: 'activeAddressCount_bg',
        hide: true,
      },
    ],
    // left: [
    //   {
    //     // 平均出块时间
    //     title: `${t('explorer_11')}`,
    //     num: '-',
    //     key: 'averageBlockTimePerHour',
    //     icon: IMG_BlockTime,
    //     className: 'averageBlockTimePerHour_bg',
    //   },
    //   {
    //     // 最新区块
    //     title: `${t('explorer_9')}`,
    //     num: '-',
    //     key: 'blocksHeight',
    //     icon: IMG_BlockHeight,
    //     noPercentile: true,
    //     className: 'blocksHeight_bg',
    //   },
    // ],
    // right: [
    //   {
    //     // 国家区
    //     title: `${t('explorer_1')}`,
    //     key: 'totalStakeAndRegionNum',
    //     num: '-',
    //     icon: IMG_NationalZone,
    //     className: 'totalStakeAndRegionNum_bg',
    //   },
    //   {
    //     // 全网交易次数
    //     title: `${t('explorer_14')}`,
    //     key: 'rollAppCountTotalTransitionHub',
    //     num: '-',
    //     icon: IMG_Transaction,
    //     noPercentile: true,
    //     className: 'rollAppCountTotalTransitionHub_bg',
    //     // mecUnit: false,
    //   },
    // ],
  }
  return list
}
const StatsCard = ({ stats, blocks }: { stats: Stats; blocks: Block[] }) => {
  const { setAverageHeightTime } = useBlockStore()
  const { t } = useTranslation()
  const [infoCardList, setInfoCardList] = useState(getList(t))
  const totalLiquidity_valueRef = useRef<string | number>('')
  const totalStakeAndRegionNumtotalStakeSum_valueRef = useRef<string | number>('')
  const totalTreasureAmount_valueRef = useRef<string | number>('')

  const getCountBySum = (value1: number, value2: number) => {
    if (isEmptyOrNil(value1) && isEmptyOrNil(value2)) return '-'
    if (isEmptyOrNil(value1)) return value2
    if (isEmptyOrNil(value2)) return value1
    return value1 + value2
  }

  const setData = () => {
    /**
     * averageBlockTimePerHour 平均出块时间[OK]
     * blocksHeight[ok]
     * totalLiquidity 总流通量[0K]
     * rollAppCountTotalTransitionHub  全网交易次数：rollapp总交易数 + gea链总交易数[OK]
     * totalStakeAndRegionNum 国家区总数[OK]
     * activeAddressCount 活跃地址数[OK]
     * totalKycCount 已认证地址数[OK]
     * totalStakeAndRegionNumtotalStakeSum 全网质押总量
     * totalTreasureAmount 全网金库总量
     */
    let averageBlockTimePerHour: number | string = infoCardList.left[0].num, // 平均出块时间
      blocksHeight = infoCardList.left[1].num, // 最新区块
      totalLiquidity: number | string = infoCardList.left[2].num, // 总流通量
      totalStakeAndRegionNumtotalStakeSum = infoCardList.right[3].num, //全网质押总量
      totalStakeAndRegionNum = infoCardList.right[0].num, // 国家区总数
      rollAppCountTotalTransitionHub = infoCardList.right[1].num, // 全网交易次数
      totalTreasureAmount = infoCardList.right[2].num, //全网金库总量
      activeAddressCount = infoCardList.right[3].num, // 活跃地址数
      totalKycCount = infoCardList.right[3].num1 // 已认证地址数

    // rollAppCountTotalTransitionHub: number | string = infoCardList.right[1].num // 全网交易次数
    if (stats) {
      if (Object.keys(stats).length == 0) return
      const {
        average_block_time_per_hour,
        total_liquidity,
        total_transaction_rollapp1,
        total_transition_hub,
        total_stake_and_region_num,
        active_address_count,
        total_treasure_amount,
        total_kyc_count,
      } = stats
      // 平均时间处理
      const averageHeightTime = average_block_time_per_hour?.[0]?.average_time
      averageBlockTimePerHour = isEmptyOrNil(averageHeightTime)
        ? '-'
        : `${formatDecimalPlaces(averageHeightTime, 1, {})}`
      // setAverageHeightTime(averageBlockTimePerHour)
      setAverageHeightTime(5)
      // 国家区总数
      const totalStakeAndRegionNum_value = total_stake_and_region_num?.aggregate?.region_num
      totalStakeAndRegionNum = isEmptyOrNil(totalStakeAndRegionNum_value)
        ? '-'
        : totalStakeAndRegionNum_value

      // 全网交易次数：rollapp总交易数 + gea链总交易数
      const total_transaction_rollapp1_value = (total_transaction_rollapp1 as any)?.[0]?.count || 0
      const total_transition_hub_value = (total_transition_hub as any)?.[0]?.count || 0
      rollAppCountTotalTransitionHub = getCountBySum(
        total_transaction_rollapp1_value,
        total_transition_hub_value,
      )

      // 活跃地址数/已认证地址数
      const activeAddressCount_value = active_address_count?.aggregate?.count
      const totalKycCount_value = total_kyc_count?.aggregate?.sum?.current_kyc_amount
      activeAddressCount = isEmptyOrNil(activeAddressCount_value) ? '-' : activeAddressCount_value
      totalKycCount = isEmptyOrNil(totalKycCount_value) ? '-' : totalKycCount_value

      // 全网质押总量
      const totalStakeAndRegionNumtotalStakeSum_value =
        total_stake_and_region_num?.aggregate?.sum?.total_stake_sum
      totalStakeAndRegionNumtotalStakeSum_valueRef.current = divideByHundredMillion(
        totalStakeAndRegionNumtotalStakeSum_value,
      )
      totalStakeAndRegionNumtotalStakeSum = isEmptyOrNil(totalStakeAndRegionNumtotalStakeSum_value)
        ? '-'
        : ugeaToGea2(totalStakeAndRegionNumtotalStakeSum_value, true).value

      // 总流通量
      const totalLiquidity_value = total_liquidity?.aggregate?.sum?.liquidity
      totalLiquidity_valueRef.current = divideByHundredMillion(
        numInPlus(`${totalLiquidity_value}`, '0'),
      )
      totalLiquidity = isEmptyOrNil(totalLiquidity_value)
        ? '-'
        : ugeaToGea2(numInPlus(`${totalLiquidity_value}`, `${0}`), true).value

      // 全网金库总量
      const totalTreasureAmount_value = total_treasure_amount?.aggregate?.sum?.treasure_amount
      totalTreasureAmount_valueRef.current = divideByHundredMillion(totalTreasureAmount_value)
      totalTreasureAmount = isEmptyOrNil(totalTreasureAmount_value)
        ? '-'
        : ugeaToGea2(totalTreasureAmount_value, true).value
    }
    if (blocks && blocks.length) {
      // 最新区块
      blocksHeight = isEmptyOrNil(blocks[0].height) ? '-' : blocks[0].height
    }
    const leftArr = [
      // averageBlockTimePerHour, // 平均出块时间
      '5 s',
      blocksHeight, // 最新区块
      totalLiquidity, // 总流通量
      totalStakeAndRegionNumtotalStakeSum,
    ]
    // const leftArr = [
    //   '5 s',
    //   blocksHeight, // 最新区块
    // ]
    const newList = JSON.parse(JSON.stringify(infoCardList))
    leftArr.forEach((value, index) => {
      newList.left[index].num = value as number
      if (index === 2) {
        newList.left[index].originNum = formatDecimalCus(totalLiquidity_valueRef.current, 8)
      }
      if (index === 3) {
        newList.left[index].originNum = formatDecimalCus(
          totalStakeAndRegionNumtotalStakeSum_valueRef.current,
          8,
        )
      }
    })
    const rightArr = [
      totalStakeAndRegionNum,
      rollAppCountTotalTransitionHub, // 全网交易次数

      totalTreasureAmount,
      activeAddressCount,
    ]
    // const rightArr = [totalStakeAndRegionNum, rollAppCountTotalTransitionHub]
    rightArr.forEach((item, index) => {
      // if (index === 3) {
      //   newList.right[index].num1 = totalKycCount
      // }
      // if (index === 1) {
      //   newList.right[index].originNum = formatDecimalCus(
      //     totalStakeAndRegionNumtotalStakeSum_valueRef.current,
      //     8,
      //   )
      // }
      if (index === 2) {
        newList.right[index].originNum = formatDecimalCus(totalTreasureAmount_valueRef.current, 8)
      }
      newList.right[index].num = item as number
    })
    setInfoCardList(newList)
  }
  useEffect(() => {
    setData()
  }, [])

  useEffect(() => {
    setData()
  }, [blocks, stats])
  return (
    <div className={Style.cardInfoWrap}>
      <div className={Style.cardInfoWrapItem}>
        {infoCardList.left.map((value, index) => {
          return (
            <div key={index} className={Style.cardBox}>
              <InfoCard cardInfo={value}></InfoCard>
            </div>
          )
        })}
      </div>
      <div className={Style.cardInfoWrapItem}>
        {infoCardList.right.map((value, index) => {
          return (
            <div
              key={index}
              className={classNames(
                index === 0 && Style.cardInfoWrapItem_child1,
                index === 1 && Style.cardInfoWrapItem_child2,
                {
                  [Style.cardBox]: index !== 3,
                },
              )}
            >
              <InfoCard cardInfo={value}></InfoCard>
            </div>
          )
        })}
      </div>
    </div>
  )
}
export default StatsCard
